import { z } from 'zod';
import { operatingHoursSchema, preferredBookingSchema } from '../booking.js';
export const publicLineItemSchema = z.object({
    serviceName: z.string(),
    // §34.4 - engine-priced lines carry serviceKind so the public page can
    // detect a ceramic coating line without string-matching serviceName;
    // legacy manual lines predate this column and come through as null.
    serviceKind: z.enum(['wrap', 'ppf', 'tint', 'ceramic', 'print']).nullable().optional(),
    coverageName: z.string(),
    materialBrand: z.string(),
    materialSeries: z.string(),
    // Engine-priced lines leave the flat material columns blank and point at an
    // inventory item instead; its name (e.g. "Inozetek PG027 Pearl Crystal
    // Blue") is the product identity the customer should see.
    inventoryName: z.string().nullable().optional(),
    color: z.string(),
    finish: z.string(),
    lineTotalCents: z.number(),
    notes: z.string(),
    estimatedMinutes: z.number().nullable(),
});
export const publicMediaSchema = z.object({ id: z.string(), kind: z.enum(['vehicle_photo', 'mockup', 'print_render']), url: z.string() });
export const publicQuoteSchema = z.object({
    shop: z.object({ name: z.string(), logoUrl: z.string().nullable(), phone: z.string().nullable() }),
    location: z.object({ name: z.string(), address: z.string().nullable() }).nullable(),
    number: z.number(),
    status: z.string(),
    vehicle: z.object({ year: z.number().nullable(), make: z.string(), model: z.string(), trim: z.string(), color: z.string() }),
    customerFirstName: z.string(),
    lineItems: z.array(publicLineItemSchema),
    subtotalCents: z.number(),
    discountName: z.string(),
    discountPct: z.number(),
    discountCents: z.number(),
    taxCents: z.number(),
    totalCents: z.number(),
    depositCents: z.number(),
    currency: z.string(),
    validUntil: z.string().nullable(),
    customerNotes: z.string(),
    customerRequestNote: z.string(),
    termsText: z.string(),
    media: z.array(publicMediaSchema),
    stripeAccountId: z.string().nullable(),
    paymentsReady: z.boolean(),
    // §34.2 - preferred booking date/time plus the shop's selectable window and
    // per-weekday operating hours, so the public page can render the same
    // picker as the internal quote form without duplicating shop-timezone logic.
    preferredDate: z.string().nullable(),
    preferredTime: z.number().nullable(),
    windowStart: z.string(),
    operatingHours: operatingHoursSchema,
});
export const publicDeclineSchema = z.object({ reason: z.string().trim().max(300).optional() });
export const publicStatusSchema = z.object({ status: z.string() });
// POST body shared by /accept and /preference. Reuses preferredBookingSchema
// (both fields optional/nullable, time-without-date rejected) plus an optional
// customer-written note (brand preference, questions, etc.). Preferences are
// submitted alongside acceptance; the /preference endpoint remains for the
// deposit flow, which saves them just before the Stripe payment confirms.
export const publicPreferenceSchema = z.intersection(preferredBookingSchema, z.object({ customerNote: z.string().trim().max(1000).optional() }));
export const publicPreferenceResponseSchema = z.object({
    preferredDate: z.string().nullable(),
    preferredTime: z.number().nullable(),
});
export const publicPayIntentResponseSchema = z.object({
    clientSecret: z.string(),
    stripeAccountId: z.string(),
    amountCents: z.number(),
    currency: z.string(),
});
//# sourceMappingURL=public.js.map